import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const  Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 35px 36px;
    background-color: ${COLORS.white};
    border-radius: 4px;
    overflow: hidden;
    width: 100%;
`;

export const  Title = styled.h2`
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    font-weight: 300;
    font-size: 24px;
    color: ${COLORS.black};
    margin: 0 0 26px 0;
    line-height: 1.33;
`;

export const  List = styled.ol`
    list-style-type: decimal;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    font-weight: 300;
    padding-left: 20px;
`;

export const  Item = styled.li`
    color: ${COLORS.grey};
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 24px;
    span {
        color: ${COLORS.black};
    }
`;
